import CardHeader from '@mui/material/CardHeader';

export type { CardHeaderProps } from '@mui/material/CardHeader';

export default CardHeader;
